<template>
  <div class="pr-1 py-4 sm:py-3 pl-10 sm:pl-6 flex flex-col w-full h-full">
    <div class="flex flex-row gap-1 w-full mb-3">
      <input
        v-model="kapalSearch"
        class="flex-1 px-3 py-3 h-8 form-input rounded-md text-xs"
        type="text"
        placeholder="cari kapal ...">
      <button
        @click="this.setActiveSubMenu('FilterListKapal')"
        class="w-8 h-8 bg-white-500 border border-white rounded-md"
        type="button"
        title="Filter Cluster">
        <i class="material-icons text-lg text-white">filter_alt</i>
      </button>
    </div>
    <div class="Scroll pr-3 w-full h-full overflow-hidden">
      <table class="table-auto w-full mb-3">
        <colgroup>
          <!-- <col style="width: 10%;" /> -->
          <col style="width: 65%;" />
          <col style="width: 35%;" />
        </colgroup>
        <thead>
          <tr>
            <th class="font-normal h-10 border border-gray-400 border-r-0 px-3 py-3 text-xs text-white text-left font-bold">KAPAL</th>
            <th class="font-normal h-10 border border-gray-400 border-l-0 px-3 py-3 text-xs text-white text-right font-bold">TRANSMITTER</th>
          </tr>
        </thead>
        <tbody class="border border-gray-400">
          <tr
            v-for="(kapal, index) in filteredListKapal()"
            :key="index"
            @click="selectKapal(kapal)"
            class="hover:bg-gray-300 cursor-pointer">
            <td class="text-xs text-left px-3 py-1 text-white">{{ kapal.properties.nama_kapal }}</td>
            <td class="text-xs text-right px-3 py-1 text-white">{{ kapal.properties.transmitter }}</td>
          </tr>
        </tbody>
      </table>
      <Pagination
        class="justify-end items-end"
        :offset="offset"
        :limit="limit"
        :total="total"
        :handler="changePage" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Pagination from './Pagination.vue'

export default {
  name: 'TableListKapal',
  data: () => ({
    offset: 0,
    limit: 50,
    total: 0,
    kapalSearch: null
  }),
  computed: {
    ...mapGetters(['listKapal'])
  },
  components: {
    Pagination
  },
  methods: {
    ...mapActions(['toZoom']),
    ...mapMutations([
      'setActiveSubMenu',
      'setKapal'
    ]),
    filteredListKapal: function () {
      const listKapal = []
      const key = this.kapalSearch ? this.kapalSearch.toLowerCase() : null
      const first = this.offset
      let last = this.kapalSearch ? this.listKapal.total : this.offset + this.limit
      let total = 0

      for (var i = first; i < last; i++) {
        if (this.listKapal.features[i]) {
          if (key) {
            if (this.listKapal.features[i].properties.nama_kapal
                .toLowerCase()
                .indexOf(key) > -1 ||
                this.listKapal.features[i].properties.nama_perusahaan
                .toLowerCase()
                .indexOf(key) > -1 ||
                this.listKapal.features[i].properties.transmitter
                .toString()
                .indexOf(key) > -1) {
              if (listKapal.length < this.limit) {
                listKapal.push(this.listKapal.features[i])
              } else {
                total += 1
              }
            }
          } else {
            listKapal.push(this.listKapal.features[i])
          }
        } else {
          break
        }
      }

      if (key) {
        this.total = total
      }

      return listKapal
    },
    changePage: async function (page) {
      this.offset = page.offset
    },
    selectKapal: function (kapal) {
      this.setKapal(kapal.properties)
      this.toZoom({
        zoom: 10,
        view: [
            kapal.properties.lat,
            kapal.properties.lon
          ]
      })
    }
  },
  mounted: function () {
    this.total = this.listKapal.total
  },
  watch: {
    kapalSearch: function () {
      this.offset = 0
    }
  }
}
</script>
